/**
 * @description This class allow to toggle a element when he has the focus.
 * @param {HTMLElement} domElement - Dom element.
 */
export default class FocusToggler {
    // eslint-disable-next-line max-statements
    constructor(domElement) {
        if(!domElement) {
            throw new Error('Element is undefined');
        }

        if(domElement.dataset.focusToggleInitialized === true) {
            throw new Error('Module already initialized');
        }

        domElement.dataset.focusToggleInitialized = 'true';

        this.domElement = domElement;
        const domTargetId = domElement.dataset.focusToogleTarget;
        this.domTarget = document.querySelector(`[data-focus-target-id=${domTargetId}]`);
        this.classToAdd = this.domTarget.dataset.focusToogleClass;
        this.activateBlurEvent = domElement.dataset.blurActivate;

        this.initEvents();
    }

    /**
     * @description Attach the events to the elements.
     */
    initEvents() {
        this.domElement.addEventListener('focus', this.handleFocus.bind(this));
        if(this.activateBlurEvent) {
            this.domElement.addEventListener('blur', this.handleBlur.bind(this));
        }
    }

    /**
     * @description Add the class on focus.
     */
    handleFocus() {
        this.domTarget.classList.add(this.classToAdd);
    }

    /**
     * @description Remove the class on blur.
     */
    handleBlur() {
        this.domTarget.classList.remove(this.classToAdd);
    }
}
